var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFactory = function SvgFactory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "factory_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#factory_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 22q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 20v-8.7q0-.6.325-1.1t.9-.75L7.6 7.6a1.01 1.01 0 0 1 .95.075Q9 7.949 9 8.5V9l3.625-1.45a.95.95 0 0 1 .938.1q.437.3.437.825V10h8v10q0 .824-.587 1.413A1.93 1.93 0 0 1 20 22zm0-2h16v-8h-8V9.95l-5 2V10l-3 1.325zm7-2h2v-4h-2zm-4 0h2v-4H7zm8 0h2v-4h-2zm7-8h-5l.9-7.125a1 1 0 0 1 .325-.625q.275-.25.65-.25h1.25q.375 0 .65.25a1 1 0 0 1 .325.625z"
  }))));
};
export default SvgFactory;